import React from "react";
import { ImHeart } from "react-icons/im";
import "./Footer.scss";
const Footer = () => {
  return (
    <footer id="footer">
      <div className="copyright">
        <div className="copyright-text">
          <p>Crafted with</p>
          <ImHeart fontSize={24} color="#e34911" className="heart" />
          <p>by</p>
          <a className="at" href="mailto:muradgm@gmail.com">
            murad muqbel
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
